/* ========================================
   Proadsy Vehicle Garage
   Persists selected vehicle across all pages:
   - Header indicator with popover
   - "Fits Your Vehicle" badges on collection cards
   - Enhanced fit badge on PDP
   ======================================== */
(function() {
  'use strict';

  var STORAGE_KEY = 'proadsy_ymmt';
  var DATA_URL = null;
  var vehicleData = null;
  var fittingHandles = null;

  /* --- Locate data URL from our script tag --- */
  var scriptEl = document.querySelector('script[data-garage-json]');
  if (scriptEl) DATA_URL = scriptEl.getAttribute('data-garage-json');

  /* --- localStorage helpers --- */
  function getSavedVehicle() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch(e) {}
    return null;
  }

  function clearVehicle() {
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
    fittingHandles = null;

    /* Animate out the indicator button before removing */
    var btn = document.querySelector('.garage-indicator__btn');
    if (btn) {
      btn.style.transition = 'opacity 0.2s, transform 0.2s';
      btn.style.opacity = '0';
      btn.style.transform = 'scale(0.9)';
      setTimeout(function() {
        renderHeaderIndicator(null);
      }, 200);
    } else {
      renderHeaderIndicator(null);
    }

    /* Animate out fit badges */
    var badges = document.querySelectorAll('.garage-fit-badge');
    badges.forEach(function(b) {
      b.style.transition = 'opacity 0.2s, transform 0.2s';
      b.style.opacity = '0';
      b.style.transform = 'translateY(4px) scale(0.95)';
    });
    setTimeout(function() {
      badges.forEach(function(b) { b.remove(); });
    }, 200);

    restorePdpBadge();
  }

  /* --- Build set of fitting handles for saved vehicle --- */
  function buildFittingHandles(saved) {
    fittingHandles = new Set();
    if (!vehicleData || !vehicleData.tree) return;

    var yearEntry = vehicleData.tree[saved.year];
    if (!yearEntry) return;
    var makeEntry = yearEntry[saved.make];
    if (!makeEntry) return;
    var modelEntry = makeEntry[saved.model];
    if (!modelEntry) return;

    var products = vehicleData.products;
    for (var typeKey in modelEntry) {
      if (!modelEntry.hasOwnProperty(typeKey)) continue;
      var indices = modelEntry[typeKey];
      for (var i = 0; i < indices.length; i++) {
        var prod = products[indices[i]];
        if (prod) fittingHandles.add(prod[0]);
      }
    }
  }

  /* ========================================
     A) HEADER VEHICLE INDICATOR
     ======================================== */
  function renderHeaderIndicator(saved) {
    var container = document.getElementById('garageIndicator');
    if (!container) return;

    if (!saved) {
      container.innerHTML = '';
      container.classList.remove('garage-indicator--active');
      return;
    }

    var label = saved.year + ' ' + saved.make + ' ' + saved.model;
    container.classList.add('garage-indicator--active');
    container.innerHTML =
      '<button type="button" class="garage-indicator__btn" id="garageToggle" aria-expanded="false" aria-label="Your vehicle: ' + label + '">' +
        '<svg class="garage-indicator__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.7-3.6A2 2 0 0013.7 5H10.3a2 2 0 00-1.6.9L6 9.5 3.5 11.1A2 2 0 002 13v3c0 .6.4 1 1 1h2"/>' +
          '<circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>' +
        '</svg>' +
        '<span class="garage-indicator__label">' + label + '</span>' +
        '<svg class="garage-indicator__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</button>' +
      '<div class="garage-popover" id="garagePopover">' +
        '<div class="garage-popover__header">Your Vehicle</div>' +
        '<div class="garage-popover__vehicle">' + label + '</div>' +
        '<div class="garage-popover__actions">' +
          '<a href="/#find-vehicle" class="garage-popover__change">Change</a>' +
          '<button type="button" class="garage-popover__clear" id="garageClear">Clear</button>' +
        '</div>' +
      '</div>';

    var toggleBtn = document.getElementById('garageToggle');
    var popover = document.getElementById('garagePopover');
    var clearBtn = document.getElementById('garageClear');

    toggleBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      popover.classList.toggle('garage-popover--open');
    });

    clearBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      clearVehicle();
    });

    document.addEventListener('click', function(e) {
      if (!container.contains(e.target)) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        popover.classList.remove('garage-popover--open');
      }
    });
  }

  /* ========================================
     B) COLLECTION / SEARCH FIT BADGES
     ======================================== */
  function applyCollectionBadges() {
    if (!fittingHandles || fittingHandles.size === 0) return;

    var cards = document.querySelectorAll('#product-grid .grid__item');
    if (!cards.length) return;

    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var href = link.getAttribute('href');
      var match = href.match(/\/products\/([^?#\/]+)/);
      if (!match) return;

      if (!fittingHandles.has(match[1])) return;
      if (card.querySelector('.garage-fit-badge')) return;

      var badge = document.createElement('div');
      badge.className = 'garage-fit-badge';
      badge.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        ' Fits Your Vehicle';

      var media = card.querySelector('.card__media') || card.querySelector('.card-wrapper');
      if (media) {
        media.style.position = 'relative';
        media.appendChild(badge);
      }
    });
  }

  function removeFitBadges() {
    var badges = document.querySelectorAll('.garage-fit-badge');
    badges.forEach(function(b) { b.remove(); });
  }

  /* ========================================
     C) PDP ENHANCED FIT BADGE
     ======================================== */
  var originalPdpBadgeHTML = null;

  function applyPdpEnhancement(saved) {
    if (!saved || !fittingHandles) return;

    var fitBadge = document.querySelector('.pdp-fit-badge');
    if (!fitBadge) return;

    /* Use data attribute first, fall back to URL parsing */
    var handle = fitBadge.getAttribute('data-product-handle');
    if (!handle) {
      var pathMatch = window.location.pathname.match(/\/products\/([^?#\/]+)/);
      if (pathMatch) handle = pathMatch[1];
    }
    if (!handle) return;

    originalPdpBadgeHTML = fitBadge.innerHTML;
    var label = saved.year + ' ' + saved.make + ' ' + saved.model;

    if (fittingHandles.has(handle)) {
      /* Product fits the saved vehicle — verified state (brand blue per color contract 2026-05-06) */
      fitBadge.classList.add('pdp-fit-badge--verified');
      fitBadge.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span>Verified Fit for Your <strong>' + label + '</strong></span>';
    } else {
      /* Product does NOT fit — neutral state with verify link */
      fitBadge.classList.add('pdp-fit-badge--neutral');
      fitBadge.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        '<span>Your <strong>' + label + '</strong> may not match this product. <a href="/#find-vehicle">Verify fitment</a></span>';
    }
  }

  function restorePdpBadge() {
    var badge = document.querySelector('.pdp-fit-badge--verified, .pdp-fit-badge--neutral');
    if (badge && originalPdpBadgeHTML) {
      badge.classList.remove('pdp-fit-badge--verified', 'pdp-fit-badge--neutral');
      badge.innerHTML = originalPdpBadgeHTML;
      originalPdpBadgeHTML = null;
    }
  }

  /* ========================================
     D) MUTATION OBSERVER FOR AJAX FILTERING
     ======================================== */
  function observeGridChanges() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    var debounceTimer = null;
    var observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        applyCollectionBadges();
      }, 100);
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  /* ========================================
     INIT
     ======================================== */
  function init() {
    var saved = getSavedVehicle();
    renderHeaderIndicator(saved);

    if (!saved || !DATA_URL) return;

    fetch(DATA_URL)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        vehicleData = data;
        buildFittingHandles(saved);
        applyCollectionBadges();
        applyPdpEnhancement(saved);
        observeGridChanges();
      })
      .catch(function(err) {
        console.warn('Garage: Failed to load vehicle data', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Multi-tab sync */
  window.addEventListener('storage', function(e) {
    if (e.key !== STORAGE_KEY) return;
    var newVehicle = getSavedVehicle();
    renderHeaderIndicator(newVehicle);
    if (newVehicle && vehicleData) {
      buildFittingHandles(newVehicle);
      removeFitBadges();
      applyCollectionBadges();
      restorePdpBadge();
      applyPdpEnhancement(newVehicle);
    } else if (!newVehicle) {
      fittingHandles = null;
      removeFitBadges();
      restorePdpBadge();
    }
  });
})();

/* Proadsy live cache hotfix 2026-05-23
   Repairs stale Shopify page-cache HTML without replacing the theme. */
(function() {
  var HOTFIX_ID = 'proadsy-live-cache-hotfix-20260523';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function addStyle() {
    if (document.getElementById(HOTFIX_ID)) return;
    var style = document.createElement('style');
    style.id = HOTFIX_ID;
    style.textContent = [
      'html body .sticky-atc,html body [data-sticky-atc],html body .section-pa-v2-pdp-sticky-atc{display:none!important;visibility:hidden!important;pointer-events:none!important}',
      'html body .section-pa-v2-pdp-info .info{min-width:0!important}',
      'html body .section-pa-v2-pdp-info .info__title{font-size:clamp(30px,2.4vw,40px)!important;line-height:1.08!important;letter-spacing:0!important;max-width:100%!important;overflow-wrap:anywhere!important;text-wrap:balance!important}',
      'html body .section-pa-v2-pdp-info .info__price,html body .section-pa-v2-pdp-info .info__price-now{overflow:visible!important;line-height:1.08!important;letter-spacing:0!important}',
      'html body .forum__inner h3,html body .forum__inner h3 p{color:#EAE2D0!important}',
      'html body .forum__inner .pa-btn--warn{background:#2563EB!important;border-color:#2563EB!important;color:#fff!important}',
      '@media(max-width:749px){html body .section-pa-v2-pdp-info .info__title{font-size:28px!important;line-height:1.12!important}}',
      '.collections-hub{background:#f4efe2;border-bottom:1px solid rgba(10,10,12,.08);padding:clamp(48px,7vw,96px) 20px 40px}',
      '.collections-hub__inner{max-width:1180px;margin:0 auto}',
      '.collections-hub__eyebrow{color:#2563EB;font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:13px;letter-spacing:.14em;text-transform:uppercase;margin-bottom:14px}',
      '.collections-hub h1{max-width:820px;margin:0;color:#0a0a0c;font-family:Inter,system-ui,sans-serif;font-size:clamp(38px,5vw,72px);line-height:.98;letter-spacing:0}',
      '.collections-hub__lead{max-width:720px;margin:20px 0 0;color:#595550;font-size:clamp(16px,1.6vw,19px);line-height:1.65}',
      '.collections-hub__routes{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin-top:32px}',
      '.collections-hub__route{display:flex;justify-content:space-between;gap:18px;min-height:112px;padding:20px;border:1px solid rgba(10,10,12,.1);border-radius:12px;background:rgba(255,255,255,.72);color:#0a0a0c;text-decoration:none}',
      '.collections-hub__route b{display:block;font-size:18px;line-height:1.2;margin-bottom:8px}',
      '.collections-hub__route span{color:#595550;font-size:13px;line-height:1.45}',
      '.collections-hub__route em{flex:0 0 auto;color:#2563EB;font-style:normal;font-weight:800}',
      '@media(max-width:760px){.collections-hub{padding:40px 20px 28px}.collections-hub__routes{grid-template-columns:1fr}.collections-hub__route{min-height:auto}}'
    ].join('');
    document.head.appendChild(style);
  }

  function textOf(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function fixHeaderLinks() {
    document.querySelectorAll('a[href="/collections"],a[href$="/collections"]').forEach(function(a) {
      var text = textOf(a).toLowerCase();
      if (text.indexOf('view all brands') !== -1) a.setAttribute('href', '/pages/all-brands');
      if (text.indexOf('view all models') !== -1) a.setAttribute('href', '/pages/all-models');
      if (text.indexOf('all products') !== -1 || text.indexOf('full catalog') !== -1 || text.indexOf('browse full catalog') !== -1) a.setAttribute('href', '/collections/all?view=proadsy-v2-master');
    });
  }

  function fixBestSellerCard() {
    var selector = 'a[href="/products/2022-2026-toyota-tundra-umbrella-sunshade"],a[href$="/products/2022-2026-toyota-tundra-umbrella-sunshade"]';
    document.querySelectorAll(selector).forEach(function(card) {
      card.setAttribute('href', '/products/toyota-sequoia-umbrella-windshield-sunshade?view=default');
      var title = card.querySelector('.ps-bs__name,h4');
      var meta = card.querySelector('.ps-bs__meta');
      var img = card.querySelector('img');
      if (title) title.textContent = 'Toyota Sequoia & Tundra Umbrella Sunshade';
      if (meta) meta.textContent = 'Sequoia 2023-2026 / Tundra 2022-2026 · 3-second umbrella';
      if (img) img.setAttribute('alt', 'Toyota Sequoia and Tundra umbrella windshield sunshade');
    });
  }

  function fixCachedPdp() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    var h1 = document.querySelector('.info__title,h1');
    var sku = document.querySelector('.info__sku');
    var titleText = textOf(h1);
    var isSequoiaTundra = location.pathname.indexOf('toyota-sequoia-umbrella-windshield-sunshade') !== -1 ||
      titleText.indexOf('Toyota Sequoia Umbrella Windshield Sunshade') !== -1;

    if (isSequoiaTundra) {
      var unifiedTitle = 'Toyota Sequoia & Tundra Umbrella Windshield Sunshade';
      document.title = unifiedTitle + ' | Proadsy';
      if (h1) h1.textContent = unifiedTitle;
      if (sku) sku.textContent = 'Laser-scanned · Custom-fit for 2023-2026 Toyota Sequoia / 2022-2026 Toyota Tundra';
      document.querySelectorAll('.info__rating-text small').forEach(function(el) {
        el.textContent = '· verified Sequoia & Tundra owners';
      });
      var trust = document.querySelector('.fit-pill,.gallery__fit-pill');
      if (trust && textOf(trust).indexOf('Toyota Sequoia') !== -1) {
        trust.textContent = 'Verified Fit · Sequoia / Tundra';
      }
      document.querySelectorAll('.sticky-atc,[data-sticky-atc],.section-pa-v2-pdp-sticky-atc').forEach(function(el) {
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.setAttribute('aria-hidden','true');
      });
    }
  }

  function fixCollectionsHub() {
    if (location.pathname !== '/collections') return;
    if (document.querySelector('.collections-hub')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var hub = document.createElement('section');
    hub.className = 'collections-hub';
    hub.innerHTML =
      '<div class="collections-hub__inner">' +
      '<div class="collections-hub__eyebrow">// Catalog Directory</div>' +
      '<h1>Find the Proadsy built for your vehicle.</h1>' +
      '<p class="collections-hub__lead">Start with a manufacturer, jump to your exact model, or browse the full product catalog. Every route leads to vehicle-specific fits, not universal sizing.</p>' +
      '<div class="collections-hub__routes">' +
      '<a class="collections-hub__route" href="/pages/all-brands"><span><b>Browse by brand</b>28 manufacturers, grouped by sunshades and covers.</span><em>-></em></a>' +
      '<a class="collections-hub__route" href="/pages/all-models"><span><b>Browse by model</b>215 model fitments across cars, trucks, SUVs, and EVs.</span><em>-></em></a>' +
      '<a class="collections-hub__route" href="/collections/all?view=proadsy-v2-master"><span><b>All products</b>Full catalog with filters, sorting, and vehicle lookup.</span><em>-></em></a>' +
      '</div></div>';
    main.insertBefore(hub, main.firstElementChild);
    var oldTitle = main.querySelector('.title--primary,h1.title');
    if (oldTitle) oldTitle.textContent = 'All Collections';
  }

  function runHotfix() {
    document.documentElement.setAttribute('data-proadsy-live-hotfix', '20260523b');
    addStyle();
    fixHeaderLinks();
    fixBestSellerCard();
    fixCachedPdp();
    fixCollectionsHub();
  }

  onReady(function() {
    runHotfix();
    setTimeout(runHotfix, 400);
    setTimeout(runHotfix, 1200);
  });
})();
